import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import type { CheckAttemptsFilters } from '../Types/Requests/CheckAttemptsRequests'
import type { CheckAttemptsListResponse } from '../Types/Responses/CheckAttemptsResponses'

const DEFAULT_ERROR = 'Não foi possível carregar as tentativas de check'
const EXPORT_ERROR = 'Não foi possível exportar as tentativas de check'

function toQuery(filters: CheckAttemptsFilters): Record<string, string | number> {
  const query: Record<string, string | number> = {}
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined && value !== null && value !== '') query[key] = value as string | number
  }
  return query
}

/** Baixa o .xlsx e devolve o link pronto para `click()` (mesmo padrão de HandoverInvites). */
function toDownloadLink(data: BlobPart, filename: string): HTMLAnchorElement {
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.style.display = 'none'
  document.body.appendChild(link)
  return link
}

export default class CheckAttemptsService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = ''
  }

  async exportXlsxByHealthUnit(
    healthUnitId: number,
    filters: CheckAttemptsFilters,
    filename = 'tentativas-de-check.xlsx'
  ): Promise<HTMLAnchorElement> {
    return this.exportXlsx(`/healthUnits/${healthUnitId}/check-attempts/xlsx`, filters, filename)
  }

  async exportXlsxByStation(
    stationId: number,
    filters: CheckAttemptsFilters,
    filename = 'tentativas-de-check.xlsx'
  ): Promise<HTMLAnchorElement> {
    return this.exportXlsx(`/stations/${stationId}/check-attempts/xlsx`, filters, filename)
  }

  private async exportXlsx(
    path: string,
    filters: CheckAttemptsFilters,
    filename: string
  ): Promise<HTMLAnchorElement> {
    try {
      const { data } = await request.get<BlobPart>(path, toQuery(filters), undefined, 'blob')
      return toDownloadLink(data, filename)
    } catch (e) {
      throw this.handleError(e, EXPORT_ERROR)
    }
  }

  async listByHealthUnit(
    healthUnitId: number,
    filters: CheckAttemptsFilters
  ): Promise<CheckAttemptsListResponse> {
    try {
      const { data } = await request.get<CheckAttemptsListResponse>(
        `/healthUnits/${healthUnitId}/check-attempts`,
        toQuery(filters)
      )
      return data
    } catch (e) {
      throw this.handleError(e, DEFAULT_ERROR)
    }
  }

  async listByStation(
    stationId: number,
    filters: CheckAttemptsFilters
  ): Promise<CheckAttemptsListResponse> {
    try {
      const { data } = await request.get<CheckAttemptsListResponse>(
        `/stations/${stationId}/check-attempts`,
        toQuery(filters)
      )
      return data
    } catch (e) {
      throw this.handleError(e, DEFAULT_ERROR)
    }
  }
}
